export const CREATE_USER_PERMISSION = 'CREATE_USER_PERMISSION'